<template>
  <div>
    <vlt-table
      v-if="!loading"
      :columns="columns"
      :rows="filteredData"
      :pagination="filteredData.length > pageSize"
      :pageSize="pageSize"
      :emptyMessage="emptyMessage"
    >
      <template slot="item" slot-scope="slotProps">
        <td >{{ slotProps.item.feedNumber }}</td>
        <td>
          <div
            v-if="isEdit(slotProps.item.feedNumber) && editableTable"
            :data-id="slotProps.item.feedNumber"
          >
            <div class="Vlt-form__element">
              <div class="Vlt-input">
                <input
                  type="text"
                  :id="`edit-cell-${slotProps.item.feedNumber}`"
                  v-model="slotProps.item.feedDescription"
                  @blur="onSave"
                  @keyup.enter="onSave"
                  v-focus
                />
              </div>
            </div>
          </div>
          <div v-else :id="slotProps.item.feedNumber" @click="onEdit" class="editableCell">
            {{ slotProps.item.feedDescription }}<span @click="()=> onClickEditIcon(slotProps.item.feedNumber, slotProps.item.feedDescription)"><vlt-icon  smaller icon="edit"/></span>
          </div>
        </td>
        <!--CAPTIONERS-->
        <td>
          <div class="Vlt-badge-group" v-if="slotProps.item.userCallInfo && slotProps.item.userCallInfo.length">
            <vlt-badge
              v-for="(item, idx) in slotProps.item.userCallInfo"
              :key="`${idx}_info_badge`"
              class="Vlt-margin--bottom1"
              large
            >
              {{item.userNumber}} - {{item.name}}
            </vlt-badge>
          </div>
          <div v-else>N/A</div>
        </td>
        <!--ACTION BUTTONS-->
        <td>
          <div class="Vlt-grid">
            <div class="Vlt-col--1of2" v-if="!userStatus">
              <div class="tooltip-item" >
                <vlt-tooltip
                  icon="info"
                  :title="$t('message.dashboard.call')"
                  class="Vlt-grey"
                  position="bottom"
                >
                  <vlt-button
                    name="call"
                    quaternary
                    app
                    large
                    :id="`d_${slotProps.item.number}`"
                    icon="call"
                    @click="onClickJoinBridge(slotProps.item)"
                  />
                </vlt-tooltip>
              </div>
            </div>
            <div :class=" !userStatus ? 'Vlt-col--1of2 Vlt-left' : 'Vlt-col'">
              <div class="tooltip-item">
                <vlt-tooltip
                  icon="info"
                  :title="$t('message.dashboard.adminDashboard.terminate_conv')"
                  class="Vlt-grey"
                  position="bottom"
                >
                  <vlt-button
                    name="deleteRecord"
                    destructive
                    app
                    large
                    :id="`d_${slotProps.item.number}`"
                    icon="phone-down"
                    @click="onClickTerminate(slotProps.item)"
                  />
                </vlt-tooltip>
              </div>
            </div>
          </div>
        </td>
      </template>
    </vlt-table>
  </div>
</template>

<script>
import {
  CALL_STATUSES,
} from "Constants/nciConstants";

import {
  VltIcon,
  VltButton,
  VltSpinner,
  VltTable,
  VltTooltip,
  VltBadge,
} from '@vonagevolta/vue';

export default {
  name: 'TableCellEdit',
  components: {
    VltIcon,
    VltButton,
    VltSpinner,
    VltTable,
    VltTooltip,
    VltBadge
  },
  directives: {
    focus: {
      inserted: function (el) {
          el.focus()
      }
    }
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    userStatus: {
      type: Boolean,
      required: true,
      default: false,
    },

    editableTable: {
      type: Boolean,
      required: true,
      default: false
    },
    filteredData: {
      type: Array,
      required: true,
      default: () => []
    },
    pageSize: {
      type: Number,
      required: true
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    saveDescription: {
      type: Function,
      required: true,
    },
    terminateBridge: {
      type: Function,
      required: true,
    },
    joinABridge: {
      type: Function,
      required: true,
    },
    emptyMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      editCell: '',
      initEditValue: '',
      editing: false,
    };
  },
  computed: {
  },
  watch: {
    filteredData: {
      immediate: true,
      handler(newProp) {
        if (newProp && newProp.length) {
          // console.log('=========== filteredData : ', newProp);
        }
      },
    },
  },
  methods: {
    isEdit(number) {
        // console.log('EVENT NUMBER: ', number)
        return this.editCell === number;
    },
    onEdit(e) {
        const id = e.target.id;
        this.initEditValue = e.target.innerText;
        this.editCell = id;
    },
    onLeaveWithoutSave(e) {
        if (this.editing) {
            this.editing = false;
            return;
        }

        const id = e.target.id;
        const numid  = id.substring(id.lastIndexOf('-') + 1);
        const item = this.filteredData.find((item)=> item.number===numid);
        if (item) {
            item.desc = this.initEditValue;
        }
        this.initEditValue = '';
        this.editCell = '';
    },
    onSave(e) {
        this.editCell = '';
        this.editing = true;
        const newDescValue = e.target.value.trim();
        const id = e.target.id;
        const numId  = id.substring(id.lastIndexOf('-') + 1);
        if (newDescValue === this.initEditValue) {
            return;
        }
        this.saveDescription({value: newDescValue, numId});
        this.editing = false;
    },
    onClickTerminate(item) {
      const { generation, version, feedNumber } = item;
      if (generation && version && feedNumber) {
        this.terminateBridge({ generation, version, feedNumber, status: CALL_STATUSES.COMPLETED });
      }
    },
    onClickJoinBridge(item) {
      if (item && item.feedNumber) {
        this.joinABridge(item.feedNumber);
      }
    },
    onClickEditIcon(id, desc) {
      if (desc) {
        this.initEditValue = desc.trim();
      }
      this.editCell = id;
    },
  },
};
</script>

<style scoped lang="scss">
  .paddingRight20 {
    padding-right: 20px;
  }

  .paddingLeft20 {
    padding-left: 28px;
  }

  .flexContainer {
    display: flex;
    align-items: stretch;
    //justify-content: space-between;
  }

  .appBoxWidth {
    width: 380px;
  }

  .stretch-height {
    height: 100%;
  }

  .width100percent {
    width: 100%;
  }

  .Vlt-btn--uppercase {
    text-transform: uppercase;
  }

  .previewContent {
    height: 240px;
    max-height: 240px;
    display: flex;
    flex-direction: column;
  }
  .previewTextContent {
    flex: 1 0 auto;
    overflow: auto;
    max-height: 188px;
    .previewText {
      max-height: 80px;
      overflow: auto;
    }
  }
  .editableCell {
    min-height: 24px;
    z-index: 1000;
    span {
      padding-left: 10px;
    }
  }
</style>
